module.exports = __webpack_public_path__ + "img/edit.ea06abbe.png";